import { IRole } from "../../types";
import { ApiPath } from "./client";
import ApiHandler from "./handler";

export default new ApiHandler<IRole>(ApiPath.ROLES, "roleId");
